<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-6 md:mb-0">
          <div class="vx-card__title mb-10">
            <h4 class="mb-4">Webhooks</h4>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full text-right">
          <vs-button @click.prevent="addWebhookPopupIsActive = true">Добавить вебхук</vs-button>
        </div>
      </div>
      <div>
        <vs-table
          no-data-text="Вебхуков нет"
          stripe
          :data="webhooks">
          <template slot="thead">
            <vs-th sort-key="name">
              Название
            </vs-th>

            <vs-th sort-key="url">
              URL
            </vs-th>

            <vs-th>
              События
            </vs-th>

            <vs-th>
              Действия
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>

              <vs-td :data="data[indextr].url">
                {{ data[indextr].url }}
              </vs-td>

              <vs-td>
                {{
                  Object.keys(data[indextr].settings).filter(option => data[indextr].settings[option]).length
                }} /
                {{
                  Object.keys(data[indextr].settings).length
                }}
              </vs-td>

              <vs-td>
                <div class="flex items-center justify-end">
                  <vs-button
                    type="flat"
                    size="large"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="clickOnEdit(indextr)"></vs-button>
                  <vs-button
                    type="flat"
                    size="large"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    @click.prevent="clickOnDelete(indextr)"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <AddWebhookPopup
      :company-slug="authUserCompany.slug"
      :channel-slug="channelSlug"
      v-if="addWebhookPopupIsActive"
      @added="addWebhookToTable"
      @close="addWebhookPopupIsActive = false"
    />
    <EditWebhookPopup
      :company-slug="authUserCompany.slug"
      :channel-slug="channelSlug"
      :webhook-slug="editWebhookSlug"
      v-if="editWebhookPopupIsActive"
      @updated="updateWebhookToTable"
      @close="editWebhookPopupIsActive = false"
    />
  </div>
</template>

<script>
import Webhook from '../../../api/http/models/webhook/Webhook'
import AddWebhookPopup from './AddWebhookPopup'
import EditWebhookPopup from './EditWebhookPopup'

import { mapGetters } from 'vuex'

export default {
  props: {
    channelSlug: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      addWebhookPopupIsActive: false,
      editWebhookPopupIsActive: false,
      webhooks: [],
      editWebhookSlug: null,
      deletingWebhook: null
    }
  },

  components: {
    AddWebhookPopup,
    EditWebhookPopup
  },

  async created () {
    const response = await Webhook.getAll(this.authUserCompany.slug, this.channelSlug)

    if (response.data) {
      this.webhooks = response.data
    }
  },

  methods: {
    addWebhookToTable (webhook) {
      this.webhooks.push(webhook)
    },

    updateWebhookToTable (webhook) {
      const index = this.webhooks.findIndex(el => el.slug === webhook.slug)
      this.webhooks.splice(index, 1, webhook)
    },

    clickOnEdit (index) {
      this.editWebhookSlug = this.webhooks[index].slug
      this.editWebhookPopupIsActive = true
    },

    clickOnDelete (index) {
      this.deletingWebhook = this.webhooks[index]
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Вы действительно хотите удалить вебхук «${this.deletingWebhook.name}»?`,
        text: `Вебхук «${this.deletingWebhook.name}» будет удален из системы.`,
        accept: this.deleteWebhook,
        acceptText: 'Да, хочу',
        cancelText: 'Нет'
      })
    },

    async deleteWebhook () {
      const response = await Webhook.delete(this.authUserCompany.slug, this.channelSlug, this.deletingWebhook.slug)

      if (response.status === 'success') {
        const index = this.webhooks.findIndex(el => el.slug === this.deletingWebhook.slug)
        this.webhooks.splice(index, 1)
      }
    }
  },

  computed: {
    ...mapGetters(['authUserCompany'])
  }
}
</script>
